import { Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

const hasOAuthCallbackParams = (params) =>
  params.has("acct1") ||
  params.has("token1") ||
  params.has("code") ||
  params.has("error");

export default function Home() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (hasOAuthCallbackParams(params)) {
      // Redirect to /login with the OAuth params
      navigate(`/login${location.search}`, { replace: true });
    }
  }, [navigate, location]);

  return (
    <div className="bg-gradient-to-b from-[#030712] via-[#050d1a] to-[#030712] text-white min-h-screen relative overflow-hidden font-sans">

      {/* Subtle animated waveform background */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,#0891b2_0%,transparent_40%)] animate-pulse-slow"></div>
        <div className="w-full h-full bg-gradient-to-r from-transparent via-cyan-950/10 to-transparent animate-wave-slow"></div>
      </div>

      {/* NAVBAR - Slimmer & Centered - BEST PLACE FOR MAIN LOGO */}
      <nav className="sticky top-0 bg-[#030712]/80 backdrop-blur-lg border-b border-cyan-950/30 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
       <Link to="/" className="flex items-center gap-3">
  <div className="w-9 h-9 rounded-full overflow-hidden border border-cyan-700/40 shadow-sm flex-shrink-0">
   <img 
  src="/logo.jpeg" 
  alt="MB" 
  className="mx-auto mt-6 mb-4 h-20 md:h-28 opacity-90 drop-shadow-[0_0_15px_rgba(6,182,212,0.5)]"
/>
  </div>
  <span className="text-xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-cyan-600">
    Matches Blooper
  </span>
</Link>

          <div className="hidden md:flex gap-7 text-sm items-center text-gray-300">
            <a href="#signals" className="hover:text-cyan-400 transition">Signals</a>
            <a href="#how" className="hover:text-cyan-400 transition">How</a>
            <a href="#access" className="hover:text-cyan-400 transition">Access</a>
            <Link 
              to="/login"
              className="bg-cyan-700/80 px-5 py-2 rounded-full hover:bg-cyan-600 transition text-sm font-medium"
            >
              Unlock — $300
            </Link>
          </div>

          <button className="md:hidden text-cyan-400">☰</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="relative pt-24 pb-32 text-center px-6 max-w-5xl mx-auto">
        {/* === OPTIONAL: HERO IMAGE / LARGE LOGO BANNER HERE === */}
        {/* Place a subtle waveform graphic or neon logo variant here for visual impact */}
        {/* Example: <img src="/waveform-hero.png" alt="Blooper Wave" className="mx-auto mb-8 h-24 opacity-80" /> */}

        <h1 className="text-4xl md:text-5xl font-black leading-tight tracking-tight">
          Catch the <span className="text-cyan-400">Blooper</span> Matches
        </h1>
        
        <p className="mt-5 text-base md:text-lg text-gray-300 max-w-2xl mx-auto">
          AI that detects rare high-payout last-digit Matches on Deriv volatility indices — 
          the moments everyone else misses.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-5">
          <Link
            to="/login"
            className="bg-cyan-600 px-8 py-3.5 rounded-full font-semibold hover:bg-cyan-500 transition shadow-lg shadow-cyan-900/40"
          >
            Get Access — $300 Lifetime
          </Link>
          <a
            href="#how"
            className="border border-cyan-600/50 px-8 py-3.5 rounded-full hover:bg-cyan-950/30 transition text-gray-200"
          >
            See It Work
          </a>
        </div>

        {/* Floating signal preview card */}
        <div className="mt-16 md:mt-24 relative max-w-md mx-auto md:absolute md:right-12 md:top-32 transform md:rotate-[-2deg]">
          <div className="bg-[#0a1325]/90 backdrop-blur-md p-6 rounded-3xl border border-cyan-800/40 shadow-2xl shadow-cyan-950/50">
            <div className="flex justify-between items-center mb-4 text-sm">
              <span className="text-cyan-400 font-semibold">LIVE BLOOPER</span>
              <span className="text-gray-500">V100 1s</span>
            </div>
            
            <div className="text-center py-4">
              <p className="text-5xl font-black text-white">MATCH</p>
              <p className="text-4xl font-bold text-cyan-300 mt-1">6</p>
            </div>

            <div className="mt-4 text-center text-sm text-gray-400">
              Probability • <span className="text-cyan-400 font-semibold">79%</span><br/>
              Entry window: <span className="text-cyan-300">00:08</span>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="py-16 border-t border-cyan-950/30">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {[
              ["93%+", "Hit Rate"],
              ["10–18", "Daily Windows"],
              ["Always On", "24/7 Scan"],
              ["Full", "Volatility Coverage"],
            ].map(([val, label]) => (
              <div key={label} className="bg-[#0a1325]/60 p-5 rounded-2xl border border-cyan-900/30">
                <p className="text-3xl md:text-4xl font-black text-cyan-400">{val}</p>
                <p className="text-xs md:text-sm text-gray-400 mt-1">{label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES - You can place small icons/images here too */}
      <section id="signals" className="py-20 px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12">
          What Makes It Different
        </h2>

        <div className="space-y-10">
          {[
            { title: "Blooper Detection", desc: "Spots rare Matches patterns ignored by standard bots." },
            { title: "Pulse Timers", desc: "Visual countdowns for perfect entry timing." },
            { title: "Confidence Scores", desc: "Shows real probability before you trade." },
            { title: "Secure Deriv Link", desc: "OAuth login — no passwords stored." },
          ].map((item, i) => (
            <div 
              key={i}
              className="bg-gradient-to-br from-[#0a1325] to-[#050d1a] p-7 rounded-3xl border border-cyan-900/40 hover:border-cyan-600/60 transition-all group"
            >
              <div className="flex items-center gap-4">
                {/* === OPTIONAL: Small icon/image per feature === */}
                {/* Example: <img src={`/icon-${i+1}.svg`} alt="" className="w-10 h-10" /> */}
                <div className="w-10 h-10 rounded-full bg-cyan-900/50 flex items-center justify-center text-cyan-400 font-black group-hover:bg-cyan-700/60 transition">
                  {i+1}
                </div>
                <div>
                  <h3 className="text-xl font-bold text-cyan-300">{item.title}</h3>
                  <p className="text-gray-300 mt-1 text-sm">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="how" className="bg-[#0a1325]/50 py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-black mb-12">
            From Tick to Payout
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              ["Scans", "Real-time digit monitoring across all indices."],
              ["Detects", "Identifies high-prob Matches blooper windows."],
              ["Delivers", "Clean signal + timer sent instantly."],
            ].map(([step, text], i) => (
              <div key={i} className="bg-[#050d1a] p-8 rounded-3xl border border-cyan-900/40">
                <div className="text-5xl font-black text-cyan-600 mb-4">{`0${i+1}`}</div>
                <h3 className="text-xl font-bold text-cyan-300 mb-3">{step}</h3>
                <p className="text-gray-300">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="access" className="py-24 px-6">
        <div className="max-w-lg mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-black mb-6">
            Lifetime Access
          </h2>
          <p className="text-gray-400 mb-10">
            Pure Matches focus. One payment. Forever.
          </p>

          <div className="bg-gradient-to-b from-[#0a1325] to-[#050814] p-10 rounded-3xl border border-cyan-800/50 shadow-2xl shadow-cyan-950/40">
            <p className="text-6xl font-black text-cyan-400">$300</p>
            <p className="text-xl text-gray-400 mt-2">One-time</p>

            <ul className="mt-8 space-y-4 text-left text-gray-200 text-sm">
              <li>✓ Last Digit Matches signals</li>
              <li>✓ Even/Odd backup included</li>
              <li>✓ All Deriv volatility indices</li>
              <li>✓ Lifetime access & updates</li>
              <li>✓ Priority support (0716691630)</li>
            </ul>

            <Link
              to="/login"
              className="mt-10 block bg-cyan-600 py-4 rounded-full font-bold text-lg hover:bg-cyan-500 transition shadow-lg"
            >
              Claim Access Now
            </Link>
          </div>
        </div>
      </section>

      {/* === NEW: FAQ SECTION === */}
      <section id="faq" className="py-20 px-6 bg-[#050814]/40">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-cyan-300">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            {[
              {
                q: "Is the signal accuracy guaranteed?",
                a: "No tool can guarantee wins — trading always involves risk. We focus on high-probability Matches setups based on historical patterns and real-time scanning, but past performance doesn't predict future results."
              },
              {
                q: "Which Deriv indices does it support?",
                a: "All major volatility indices (V10, V25, V50, V75, V100 — 1s & standard ticks) are fully supported. Works best on 1s volatility for fast Matches signals."
              },
              {
                q: "How secure is my Deriv account with this tool?",
                a: "Extremely secure. We only use official Deriv OAuth login — we never store or see your password or account details."
              },
              {
                q: "Do I need experience to use Matches Blooper AI?",
                a: "Basic knowledge of Deriv and last-digit Matches trading helps, but the tool provides clear probability scores, timers, and entry guidance to make execution straightforward."
              },
              {
                q: "What happens after I pay the $300?",
                a: "Lifetime access is granted instantly after payment. You'll get login credentials, setup instructions, and priority support via WhatsApp (0716691630)."
              },
              {
                q: "Is there a free trial or demo?",
                a: "Currently no free trial due to the specialized real-time nature. However, we offer clear support before purchase — message us on 0716691630 with questions."
              },
              {
                q: "What if I have issues or need help?",
                a: "Reach out anytime via WhatsApp/Call: 0716691630. Priority support is included for all users."
              },
            ].map((faq, i) => (
              <details 
                key={i}
                className="bg-[#0a1325]/70 p-6 rounded-2xl border border-cyan-900/40 group open:border-cyan-600/60 transition-all"
              >
                <summary className="font-semibold text-lg text-cyan-300 cursor-pointer flex justify-between items-center">
                  {faq.q}
                  <span className="text-cyan-500 group-open:rotate-180 transition">▼</span>
                </summary>
                <p className="mt-4 text-gray-300 text-sm leading-relaxed">
                  {faq.a}
                </p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-12 text-center text-gray-500 text-sm border-t border-cyan-950/30">
        <p>© 2026 Matches Blooper AI</p>
        <p className="mt-2">Contact: 0716691630 • Trading carries significant risk of loss</p>
      </footer>

    </div>
  );
}
